import React, { useEffect, useState } from "react";
import { PageHeader } from "./Dashboard";
import { api } from "@/lib/api";
import { Mic, Phone } from "lucide-react";
import { toast } from "sonner";

const field = "w-full rounded-lg border border-white/10 bg-[var(--jr-surface-2)] px-3 py-2 text-sm text-white outline-none";
const btn = "px-3 py-2 rounded-lg bg-[var(--jr-brand)] text-white text-sm font-medium inline-flex items-center gap-2";

export default function Voice() {
    const [status, setStatus] = useState(null);
    const [candidates, setCandidates] = useState([]);
    const [candidateId, setCandidateId] = useState("");
    const [note, setNote] = useState("");
    const [last, setLast] = useState(null);
    const [intakes, setIntakes] = useState([]);

    const loadIntakes = () => api.get("/ats-core/voice/intakes").then((r) => setIntakes(r.data)).catch(() => {});

    useEffect(() => {
        api.get("/ats-core/voice/status").then((r) => setStatus(r.data)).catch(() => {});
        api.get("/ats-core/candidates", { params: { limit: 200 } }).then((r) => setCandidates(r.data)).catch(() => {});
        loadIntakes();
    }, []);

    const submit = async (action) => {
        try {
            const r = await api.post("/ats-core/voice/intakes", {
                candidate_id: candidateId || null,
                note,
                action,
            });
            setLast(r.data);
            setNote("");
            toast.message(action === "call"
                ? "Call niet geplaatst — geen provider geconfigureerd"
                : "Intake opgeslagen");
            await loadIntakes();
        } catch (e) {
            const d = e?.response?.data?.detail;
            toast.error(typeof d === "string" ? d : "Voice-actie mislukt");
        }
    };

    return (
        <PageHeader title="Voice" subtitle="Intake en bel-actie in Jeremai. Een echte call vertrekt pas als een provider-hook bewezen is.">
            <div className="rounded-2xl border border-[var(--jr-brand)]/30 bg-[var(--jr-surface)] p-6 mb-6" data-testid="voice-panel">
                <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--jr-amber)]">
                    {status?.mode || "laden"} · provider {status?.provider || "geen"}
                </div>
                <p className="mt-3 text-sm text-[var(--jr-text-2)] max-w-2xl" data-testid="voice-todo">{status?.todo}</p>
                <div className="mt-5 grid gap-3 max-w-xl">
                    <select className={field} value={candidateId} data-testid="voice-candidate"
                        onChange={(e) => setCandidateId(e.target.value)}>
                        <option value="">Koppel aan kandidaat (optioneel)</option>
                        {candidates.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                    <textarea className={field} rows={4} placeholder="Intake-notitie of belcontext" value={note}
                        data-testid="voice-note" onChange={(e) => setNote(e.target.value)} />
                    <div className="flex flex-wrap gap-2">
                        <button className={btn} data-testid="voice-intake" onClick={() => submit("intake")}>
                            <Mic size={14} /> Intake opslaan
                        </button>
                        <button className={btn} data-testid="voice-call" onClick={() => submit("call")}>
                            <Phone size={14} /> Bel-actie
                        </button>
                    </div>
                </div>
                {last && (
                    <p className="mt-4 text-sm" data-testid="voice-result">
                        Opgeslagen. call_placed={String(last.call_placed)}. Geen stille succes-call.
                    </p>
                )}
            </div>
            <div className="space-y-2" data-testid="voice-intakes">
                {intakes.map((row) => (
                    <div key={row.id} className="rounded-xl border border-white/8 bg-[var(--jr-surface)] px-4 py-3 text-sm">
                        <span className="font-mono text-[10px] uppercase text-[var(--jr-text-3)]">{row.action}</span>
                        <span className="ml-2 text-[var(--jr-text-2)]">{row.note || "—"}</span>
                        <span className="ml-2 text-[10px] text-[var(--jr-text-3)]">call_placed={String(row.call_placed)}</span>
                    </div>
                ))}
            </div>
        </PageHeader>
    );
}
